import { render, staticRenderFns } from "./ClearRefinements.vue?vue&type=template&id=078b7591"
import script from "./ClearRefinements.vue?vue&type=script&lang=js"
export * from "./ClearRefinements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports